import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme, toRem } from 'design';

interface ILoaderProps {
  size?: number;
  stroke?: number;
  color?: string;
  className?: string;
}

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  width: auto;
  height: auto;
`;

const rotateClockwise = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LOADER_COLOR = theme.color.neutral[200];

const Spin = styled.span<Partial<ILoaderProps>>`
  display: flex;
  position: relative;
  width: ${({ size }) => (size ? toRem(size) : toRem(22))};
  height: ${({ size }) => (size ? toRem(size) : toRem(22))};
  border-radius: 50%;
  border-width: ${({ stroke }) => (stroke ? toRem(stroke) : toRem(3))};
  border-style: solid;
  border-color: ${({ color }) => color || LOADER_COLOR} ${({ color }) => color || LOADER_COLOR} ${({ color }) => color || LOADER_COLOR} transparent;
  animation: ${rotateClockwise} 1000ms linear infinite;
`;

const LoaderSpin: React.FC<ILoaderProps> = ({ size, stroke, color, className }) => (
  <Layout className={className}>
    <Spin size={size} stroke={stroke} color={color} />
  </Layout>
);

export default LoaderSpin;
